import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Beneficiary } from "../../../../models/Beneficiary";
import { shortDateFormat } from "../../../../utils/functions";
import { RelationshipLabel } from "../../../../enums/Relationship";
import Button from "../../../Button";
import FilteredTable from "../../../FilteredTable";
import { PolicyBeneficiaryModal } from "./PolicyBeneficiaryModal";
import { BookOpenIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/solid";

interface Props {
  //isNewClient:boolean
  beneficiaries: Beneficiary[];
  canEditClient: boolean;
  removeBeneficiary: (index: number) => void;
  updateBeneficiary: (index: number, beneficiary: Beneficiary) => void;
}

export const PolicyBeneficiariesTable: React.FC<Props> = ({
    //isNewClient,
    beneficiaries,
    canEditClient,
    removeBeneficiary,
    updateBeneficiary,
}) => {
    const { t } = useTranslation();

    const columns = useMemo(() => {
        const showColumns = [
            {
                Header: t("FIRST_NAME"),
                accessor: "first_name",
            },
            {
                Header: t("LAST_NAME"),
                accessor: "last_name",
            },
            {
                Header: t("DATE_OF_BIRTH"),
                Cell: (row: any) => row.row.original.date_of_birth ? `${shortDateFormat(row.row.original.date_of_birth)}` : "-",
            },
            {
                Header: t("RELATIONSHIP"),
                Cell: (row: any) => row.row.original.relationship_id ? `${RelationshipLabel(row.row.original.relationship_id)}` : "-",
            }
        ]

        const actions = {
            id: "actions",
            Header: "",
            Cell: (row: any) => {
                return (
                    <div className="flex flex-row justify-center divide-x">
                    <Button
                        isTerciary
                        iconOnly
                        tooltip={t("UPDATE_BENEFICIARY")}
                        onClick={() => updateBeneficiary(row.row.index, row.row.original)}
                        classNames="mr-2"
                    >
                        <PencilIcon className="h-5 aspect-square text-blue" />
                    </Button>
                    <Button
                        isTerciary
                        iconOnly
                        tooltip={t("DELETE_BENEFICIARY")}
                        onClick={() => removeBeneficiary(row.row.index)}
                        classNames="mr-2"
                    >
                        <TrashIcon className="h-5 aspect-square text-red-600" />
                    </Button>
                    </div>
                );
            },
        };
      
        const backupActions = {
            id: "actions",
            Header: "",
            Cell: (row: any) => {
              return (
                <div className="flex flex-row justify-center divide-x">
                  <Button
                    isTerciary
                    tooltip={t("BENEFICIARY_INFORMATION")}
                    iconOnly
                    onClick={() => updateBeneficiary(row.row.index, row.row.original)}
                    classNames="mr-2"
                  >
                    <BookOpenIcon className="h-5 aspect-square text-blue" />
                  </Button>
                </div>
              );
            }
        };
    
        if(!canEditClient) {
            return [...showColumns, backupActions]
        }
        
        return [...showColumns, actions]

    },[removeBeneficiary, t, updateBeneficiary]);

    return (
        <FilteredTable
            columns={columns}
            data={beneficiaries}
            hasSearchBar={false}
            noPadding={true}
        />
    );
};